import { FC } from "react";
import { Editor } from '@tinymce/tinymce-react';

interface ITextEditorProps {
    initialContent?: string
}

export const TextEditor: FC<ITextEditorProps> = ({initialContent = ""}) => {
    return <div>
        <Editor
            initialValue={initialContent}
            init={{
            height: 500,
            menubar: false,
            toolbar: 'undo redo | formatselect | ' +
            'bold italic backcolor | alignleft aligncenter ' +
            'alignright alignjustify | bullist numlist outdent indent | ' +
            'removeformat | help',
            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
            }}
        />
    </div>
}